var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page profile-command-page" }, [
    _c("div", { staticClass: "saas-hero card-saas profile-command-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/user" } }, [
              _vm._v(_vm._s(_vm.trans("user.user"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("user.email")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(
            _vm._s(_vm.userForm.first_name) +
              " " +
              _vm._s(_vm.userForm.last_name)
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "profile-command-hero__subtitle" }, [
          _vm._v(
            _vm._s(_vm.trans("user.email")) +
              " · " +
              _vm._s(_vm.trans("template.template"))
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nk-block" }, [
      _c(
        "div",
        { staticClass: "card-saas card-saas--flush admin-user-profile-card" },
        [
          _c("div", { staticClass: "card-aside-wrap" }, [
            _c(
              "div",
              { staticClass: "card-content" },
              [
                _c("user-sidebar", { attrs: { menu: "email", id: _vm.id } }),
                _vm._v(" "),
                _c("div", { staticClass: "card-inner admin-user-form-inner" }, [
                  _c("div", { staticClass: "nk-block" }, [
                    _c(
                      "div",
                      { staticClass: "nk-block-head admin-user-form-head" },
                      [
                        _c("h4", { staticClass: "admin-user-section-title" }, [
                          _vm._v(_vm._s(_vm.trans("user.email"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            return _vm.emailForm.errors.clear(
                              $event.target.name
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.trans("template.template"))),
                            ]),
                            _vm._v(" "),
                            _c("v-select", {
                              attrs: {
                                label: "name",
                                name: "template_id",
                                id: "template_id",
                                options: _vm.templates,
                                placeholder: _vm.trans(
                                  "template.select_template"
                                ),
                              },
                              on: {
                                select: _vm.getTemplateContent,
                                close: function ($event) {
                                  return _vm.emailForm.errors.clear(
                                    "template_id"
                                  )
                                },
                                remove: function ($event) {
                                  _vm.emailForm.template_id = ""
                                },
                              },
                              model: {
                                value: _vm.selected_template,
                                callback: function ($$v) {
                                  _vm.selected_template = $$v
                                },
                                expression: "selected_template",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.emailForm,
                                "prop-name": "template_id",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.trans("template.subject"))),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailForm.subject,
                                  expression: "emailForm.subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "subject",
                                placeholder: _vm.trans("user.subject"),
                              },
                              domProps: { value: _vm.emailForm.subject },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.emailForm,
                                    "subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.emailForm,
                                "prop-name": "subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("html-editor", {
                              attrs: {
                                name: "body",
                                model: _vm.emailForm.body,
                                isUpdate: "true",
                                "reload-content": _vm.reload_content,
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.emailForm, "body", $event)
                                },
                                clearErrors: function ($event) {
                                  return _vm.emailForm.errors.clear("body")
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.emailForm,
                                "prop-name": "body",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "admin-user-form-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.trans("message.send")))]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl",
                attrs: {
                  "data-content": "userAside",
                  "data-toggle-screen": "xxl",
                  "data-toggle-overlay": "true",
                  "data-toggle-body": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-inner-group",
                    attrs: { "data-simplebar": "" },
                  },
                  [_c("user-summary", { attrs: { user: _vm.user } })],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }